import React from "react";

const PARENT_URL = "https://mythosindiastudio.com/";
const CONTACT_URL = "https://mythosindiastudio.com/contact";

export function ParentFooter() {
  return (
    <footer className="mt-auto border-t border-[var(--as-border)] bg-[var(--as-bg-alt)] pb-24 md:pb-0" data-testid="parent-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 grid md:grid-cols-3 gap-8 items-start">
        {/* Column 1: Product brand — MYTHIVA */}
        <div>
          <img
            src="/mythiva-logo.png"
            alt="MYTHIVA™"
            className="h-8 w-auto object-contain select-none"
            draggable="false"
            data-testid="footer-brand-logo"
          />
          <div className="mt-2 text-[10px] uppercase tracking-[0.22em] font-bold text-[var(--as-text-secondary)]">
            Associate Skill · Skills-first marketplace
          </div>
          <p className="text-sm text-[var(--as-text-secondary)] mt-3 leading-relaxed max-w-xs">
            A skills-first, multilingual talent and MSME discovery platform for India. Show your skill. Get hired.
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs mt-4">
            <a href="/opportunities" className="text-[var(--as-primary)] font-bold hover:text-[var(--as-accent)]">Jobs</a>
            <a href="/search" className="text-[var(--as-primary)] font-bold hover:text-[var(--as-accent)]">Search</a>
            <a href="/sponsorship-programs" className="text-[var(--as-primary)] font-bold hover:text-[var(--as-accent)]">Sponsors</a>
            <a href="/donate" className="text-[var(--as-primary)] font-bold hover:text-[var(--as-accent)]">Donate</a>
            <a href="/investors" className="text-[var(--as-primary)] font-bold hover:text-[var(--as-accent)]">Why</a>
          </div>
        </div>

        {/* Column 2: Legal parent entity */}
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[var(--as-text-secondary)]">A product of</div>
          <a
            href={PARENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-3 group"
            data-testid="parent-brand-link"
          >
            <div className="font-extrabold text-[var(--as-primary)] leading-tight text-base group-hover:text-[var(--as-accent)] transition-colors">
              Mythos India Studios Private Limited
            </div>
            <div className="text-[11px] text-[var(--as-accent)] font-bold mt-1 uppercase tracking-wider">
              mythosindiastudio.com ↗
            </div>
          </a>
          <div className="text-[11px] text-[var(--as-text-secondary)] mt-3 leading-relaxed space-y-0.5">
            <div><span className="font-bold text-[var(--as-primary)]">CIN:</span> U62010TS2026PTC221089</div>
            <div><span className="font-bold text-[var(--as-primary)]">Registered:</span> Telangana, India</div>
          </div>
          <p className="text-[10px] text-[var(--as-text-secondary)] mt-3 leading-relaxed">
            MYTHIVA and the MYTHIVA logo are trademarks of Mythos India Studios Private Limited.
          </p>
        </div>

        {/* Column 3: Legal / contact */}
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[var(--as-text-secondary)]">Contact & legal</div>
          <ul className="mt-3 space-y-1.5 text-sm">
            <li>
              <a href={CONTACT_URL} target="_blank" rel="noopener noreferrer" className="text-[var(--as-primary)] font-semibold hover:text-[var(--as-accent)]" data-testid="footer-contact-link">
                Contact us ↗
              </a>
              <span className="block text-[11px] text-[var(--as-text-secondary)]">via Mythos India Studios</span>
            </li>
            <li>
              <a href={PARENT_URL} target="_blank" rel="noopener noreferrer" className="text-[var(--as-primary)] font-semibold hover:text-[var(--as-accent)]">
                Corporate website ↗
              </a>
            </li>
            <li>
              <a href={CONTACT_URL} target="_blank" rel="noopener noreferrer" className="text-[var(--as-primary)] font-semibold hover:text-[var(--as-accent)]" data-testid="footer-investors-link">
                Investor enquiries ↗
              </a>
            </li>
          </ul>
          <p className="text-[11px] text-[var(--as-text-secondary)] mt-4 leading-relaxed">
            © {new Date().getFullYear()} Mythos India Studios Private Limited. All rights reserved.<br />
            MYTHIVA™ · Associate Skill is a product of Mythos India Studios.
          </p>
        </div>
      </div>
    </footer>
  );
}
